export const cropsReducer = (state = {loading:true,result:null,crops:null,crop:null} , action) => {
    switch (action.type) {
        case 'CROP_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'CROPS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                crops: action.payload
            }
        case 'CROP_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                crop: action.payload
            }
        case 'CROPS_BY_PLOT_SUCCESS':
            return {
                ...state,
                loading:false,
                crops: action.payload
            }
        case 'CROP_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                crops: state.crops.filter(crop => crop._id !== action.payload.idCrop)
            }
        case 'CROP_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'CROP_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'CROP_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'CROP_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

